import { StatModifiers } from "../../utils/statModifiers";

export enum ItemStateEnum {
  Ready = 1,
  InUse = 2,
  Merged = 3,
  ForSale = 4,
}
export enum ItemBonusStatEnum {
  Health = 0,
  Armor = 1,
  Healing = 3,
  MagicResistance = 4,
  Damage = 5,
  Range = 6,
}
export enum ItemSlotEnum {
  Helmet = 1,
  Chest = 2,
  Legs = 3,
  Boots = 4,
  Gloves = 5,
  Weapon = 6,
}
export const ItemStateType = {
  1: "ready",
  2: "inUse",
  3: "merged",
  4: "forSale",
};

export const ItemBonusStat = {
  0: "health",
  1: "armor",
  3: "healing",
  4: "magicResistance",
  5: "damage",
  6: "range",
};

export const ItemBonusStatIcons = {
  0: "/assets/images/icons/icon-health-restore.png",
  1: "/assets/images/icons/armor.png",
  3: "/assets/images/icons/mage-heal.png",
  4: "/assets/images/icons/team-magic-resist.png",
  5: "/assets/images/icons/damage.png",
  6: "/assets/images/icons/range.png",
};

export const ItemSlotNames = {
  1: "helmet",
  2: "mail",
  3: "chausses",
  4: "boots",
  5: "gloves",
  6: "weapon",
};

export interface ItemType {
  id: number;
  name: string;
  slot: ItemSlotEnum;
  bonusStat: ItemBonusStatEnum;
  bonusValue: number;
  image: string;
  troopIds: string;
  setId?: number;
  setBonus?: number;
}
export type SetBonus = {
  setId: number;
  setName: string;
  setDescription: string;
  itemsOwned: number;
  totalItems: number;
  isComplete: boolean;
  bonusStat: number;
  bonusPercent: number;
};

export interface PlayerItemType {
  // The modified bonus while an event stat modifier runs; statModifiers then holds the original.
  bonusValue?: number;
  statModifiers?: StatModifiers;
  bonusStat?: ItemBonusStatEnum;
  id: number;
  image: string;
  price?: number;
  item: ItemType;
  itemId: number;
  level: number;
  playerId: number;
  state: ItemStateEnum;
  sellOrder?: {
    id: number;
    itemType: number;
    itemId: number;
    state: number;
    quantity: number;
    filled: number;
    orderType: number;
    playerId: number;
    registerDate: string;
    lastUpdate: string;
    clegPrice: number;
    itemLevel: number;
  };
}
